import AlphaHelpers from '../abstracts/classes/alpha-helpers'
import Logger from '@nematis/js-snippets/assets/js/logging/debug-logger'

document.addEventListener('alpha.loaded', (e) => {
  const alpha = e.detail.emitter
  const alphaConfig = alpha.getConfig()

  document.addEventListener('rsq.service.googleadsgtag.ready', (ev) => {
    const uniqueId = ev.detail.service.getUniqueIdentifier()
    const clickConversions = alphaConfig.clickConversions || []

    clickConversions.forEach((clickConversion) => {
      const label = clickConversion.label || ''
      const type = clickConversion.type || ''
      let selector = clickConversion.selector || ''
      const count = clickConversion.count || 'multiple'
      const comment = clickConversion.comment || null

      switch (type) {
        case 'phone':
          selector = `a[href^="tel:${selector}"]`
          break
        default:
          break
      }

      let elements = []
      switch (count) {
        case 'multiple':
          elements = AlphaHelpers.smartQuerySelectorAll(selector)
          break
        default:
          elements.push(document.querySelector(selector))
          break
      }

      elements.forEach((element) => {
        element.addEventListener('click', (event) => {
          gtag('event', 'conversion', {
            // eslint-disable-next-line camelcase
            send_to: `${uniqueId}/${label}`,
            // eslint-disable-next-line camelcase
            event_callback: () => {
              let value = null
              switch (type) {
                case 'phone':
                  value = element.getAttribute('href').replace('tel:', '')
                  break
                default:
                  break
              }

              const log = ['Conversion au clic', comment, value].filter((v) => v).join(' - ')
              Logger.log(log, event, element)
            }
          })
        }, {
          once: true
        })
      })
    })
  })
})
